export class OPathFunctions {
  prependText: string;
  Categories: OPathFunctionCategory[] = [];
  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.Categories = [];

      if (data.Categories) {
        data.Categories.forEach((c: any) => {
          this.Categories.push(new OPathFunctionCategory(c));
        });
      }
    }
  }
}

export class OPathFunctionCategory {
  designation: string;
  Functions: OPathFunction[];

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.Functions = [];

      if (data.Functions) {
        data.Functions.forEach((f: any) => {
          this.Functions.push(new OPathFunction(f));
        });
      }
    }
  }
}

export class OPathFunction {
  name: string;
  description: string;
  Parameters?: FunctionParameter[];

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.Parameters = [];

      if (data.Parameters) {
        data.Parameters.forEach((p: any) => {
          this.Parameters.push(new FunctionParameter(p));
        });
      }
    }
  }
}

export class FunctionParameter {
  name: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
